import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';
import {
  fetchRecord,
  reconcilePatientEMR,
} from 'store/currentPatient/actions/fhir';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchRecord.STARTED]: handleActionStart,
  [reconcilePatientEMR.STARTED]: handleActionStart,
  [reconcilePatientEMR.SUCCEEDED]: state => {
    state.isLoading = false;
  },
  [fetchRecord.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data;
  },
  [fetchRecord.FAILED]: handleActionError,
  [reconcilePatientEMR.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.record,
  [clearCurrentPatient]: () => initialState,
});
